module.exports = __webpack_public_path__ + "img/right-top-shape.f796952d.svg";